import { decricaoSituacao } from './descricao-situacao';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { filter } from 'rxjs';
import {
  ConsultaProtocolo,
  DadosAtendimento,
} from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';

@Component({
  selector: 'app-acompanhar-servico',
  templateUrl: './acompanhar-servico.component.html',
  styleUrls: ['./acompanhar-servico.component.css'],
})
export class AcompanharServicoComponent implements OnInit {
  TAMANHO_MAXIMO_ARQUIVOS: number = 5242880;
  ANEXO_DOCUMENTO_COMPLEMENTAR = 'anexo_documento_complementar';
  SITUACAO_PENDENTE = 'P';
  anexos: File[] = [];

  decricaoSituacao?: any;

  protocolo?: string | null;
  id?: number | null;
  ano?: number | null;
  loading = false;

  dadosAtendimento?: DadosAtendimento;
  dadosProtocolo?: ConsultaProtocolo;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: ServicoService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.decricaoSituacao = decricaoSituacao;
    this.activatedRoute.paramMap
      .pipe(filter((data) => data.has('id') && data.has('ano')))
      .subscribe((params) => {
        this.id = Number(params.get('id'));
        this.ano = Number(params.get('ano'));

        this.pesquisar();
      });
  }

  pesquisarProtocolo(): void {
    if (this.protocolo) {
      this.loading = true;
      this.service.getInformacoesProtocolo(this.protocolo).subscribe({
        next: (dados) => {
          this.dadosProtocolo = dados;
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            detail: 'Dados do protocolo não encontrados',
          });
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }

  pesquisar(): void {
    if (this.id && this.ano) {
      if (this.id >= 300000) {
        this.loading = true;
        this.service.getDadosAtendimento(this.id, this.ano).subscribe({
          next: (dados) => {
            this.dadosAtendimento = dados;
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              detail: 'Dados do atendimento não encontrados',
            });
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
          },
        });
      } else {
        window.open(
          `https://www.casan.com.br/situacaoatendimento/detalhes?atendimento=${this.id}&ano=${this.ano}`,
          '_blank'
        );
      }
    }
  }

  _buscarAnexos(): File[] {
    let files: File[] = [];
    let quantidadeArquivosExistentes =
      this.dadosAtendimento?.qtdArquivoComplementar || 0;

    for (let i = 0; i < this.anexos.length; i++) {
      var splitName = this.anexos[i].name.split('.');
      var extension = splitName[splitName.length - 1];
      var sequence = (i + 1 + quantidadeArquivosExistentes)
        .toString()
        .padStart(2, '0');
      var fileName = `${this.ANEXO_DOCUMENTO_COMPLEMENTAR}_${sequence}.${extension}`;
      files.push(
        new File([this.anexos[i]], fileName, {
          type: this.anexos[i].type,
        })
      );
    }

    return files;
  }

  onFileSelect(event: FileSelectEvent) {
    this.anexos = [...this.anexos, ...event.files];
  }

  onFileRemove(event: FileRemoveEvent) {
    this.anexos = [...this.anexos.filter((curr) => curr != event.file)];
  }

  onClearFiles($event: Event) {
    this.anexos = [];
  }

  enviarArquivos(): void {
    if (!this.id || !this.ano) return;
    this.loading = true;

    const formData = new FormData();
    const arquivos = this._buscarAnexos();

    arquivos.forEach((arquivo) => {
      formData.append('arquivos', arquivo, arquivo.name);
    });

    this.service
      .postArquivosComplementares(this.id, this.ano, formData)
      .subscribe({
        next: (dados) => {
          this.dadosAtendimento = dados;
          this.anexos = [];
          this.loading = false;
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            detail: 'Erro ao enviar os arquivos',
          });
          this.loading = false;
        },
      });
  }

  confirmarAbrigoPadrao(event: Event) {
    if (this.dadosProtocolo) {
      this.loading = true;
      this.service.postLiberarSuspesao(this.dadosProtocolo).subscribe({
        next: (dados) => {
          this.dadosProtocolo = dados;
          this.messageService.add({
            severity: 'info',
            detail: 'Protocolo liberado!',
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            detail: 'Não foi possível liberar a suspensão.',
          });
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }
}
